import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';
import Toggle from '@adsk/alloy-react-toggle';

import i18n from '../../utils/i18n';
import { useReactScanStorage } from '../../utils/reactScan';

/**
 * Toggle component for enabling/disabling ReactScan
 */
const ToggleReactScan: FC = () => {
  const { enabled, handleToggle } = useReactScanStorage();

  return (
    <Flex
      display="inline-flex"
      height="32px"
      borderBottom={`1px solid ${theme.colors.charcoal200}`}
      padding="0 8px"
      minWidth={170}
      data-testid="dev-details-react-scan"
    >
      <Flex alignItems="center" justifyContent="space-between" flex={1}>
        <Text typography="bodyMediumBold">{i18n.t('REACT_SCAN')}</Text>
        <Toggle
          checked={enabled}
          onChange={handleToggle}
          data-testid="dev-details-react-scan-toggle"
          aria-label={i18n.t('REACT_SCAN')}
        />
      </Flex>
    </Flex>
  );
};

export default ToggleReactScan;
